"use strict";

var cov_1o4vxlgso7 = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\localStrings.js";
  var hash = "b0cfb41d06995d299ef2f354f926162fd377a9fc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\localStrings.js",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 16
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "1": {
        start: {
          line: 40,
          column: 27
        },
        end: {
          line: 57,
          column: 1
        }
      },
      "2": {
        start: {
          line: 41,
          column: 13
        },
        end: {
          line: 41,
          column: 47
        }
      },
      "3": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 45,
          column: 3
        }
      },
      "4": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 16
        }
      },
      "5": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 50,
          column: 3
        }
      },
      "6": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 16
        }
      },
      "7": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 45
        }
      },
      "8": {
        start: {
          line: 51,
          column: 16
        },
        end: {
          line: 51,
          column: 33
        }
      },
      "9": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 55,
          column: 3
        }
      },
      "10": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 42
        }
      },
      "11": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 56,
          column: 17
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 40,
            column: 27
          },
          end: {
            line: 40,
            column: 28
          }
        },
        loc: {
          start: {
            line: 40,
            column: 35
          },
          end: {
            line: 57,
            column: 1
          }
        },
        line: 40
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        }, {
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        }],
        line: 43
      },
      "1": {
        loc: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        }, {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        }],
        line: 47
      },
      "2": {
        loc: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        }, {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        }],
        line: 53
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "b0cfb41d06995d299ef2f354f926162fd377a9fc"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localString = void 0; //
// Translate strings into different languages
// Then use localString(id) to return the language specific string to use
//
// To use:
// 1. Import:
//    import { Tooltip } from '@material-ui/core';
//    import { localString } from '../../core/localStrings';
//
// 2. Update string ids as needed
// 3. Wrap button (if a tooltip):
// <Tooltip title={localString(iconTooltip)} arrow>
//   <Translate />
// </Tooltip>
// 4. -or- just call exported function, where a string is needed:
//
//    localString(stringid)
//

var strings = (cov_1o4vxlgso7.s[0]++, {
  en: {
    //ViewVersions: 'View Versions',
    ManageVersions: 'Manage Versions',
    AddResource: 'Add Resource',
    ResourcePath: 'Resource Path',
    ExpandChapter: 'Expand Chapter',
    CollapseChapter: 'Collapse Chapter',
    ViewLicense: 'View License',
    ExpandScripturePane: 'Expand Scripture Pane',
    CloseScripturePane: 'Close Scripture Pane',
    Remove: 'Remove',

    /* do not remove these two */
    StringMissing: 'String Id missing',
    LangNotSupported: 'Language not supported'
  },
  el: {
    StringMissing: 'λείπει το εργαλείο'
  }
});
cov_1o4vxlgso7.s[1]++;

var localString = function localString(id) {
  cov_1o4vxlgso7.f[0]++;
  var lang = (cov_1o4vxlgso7.s[2]++, navigator.language.split(/-|_/)[0]); // if language is unknown (not sure this can actually happen)

  cov_1o4vxlgso7.s[3]++;

  if (lang === undefined) {
    cov_1o4vxlgso7.b[0][0]++;
    cov_1o4vxlgso7.s[4]++;
    lang = 'en';
  } else {
    cov_1o4vxlgso7.b[0][1]++;
  } // if there are no strings for the language


  cov_1o4vxlgso7.s[5]++;

  if (strings[lang] === undefined) {
    cov_1o4vxlgso7.b[1][0]++;
    cov_1o4vxlgso7.s[6]++;
    lang = 'en';
    cov_1o4vxlgso7.s[7]++;
    return strings[lang]['LangNotSupported'];
  } else {
    cov_1o4vxlgso7.b[1][1]++;
  }

  var lstring = (cov_1o4vxlgso7.s[8]++, strings[lang][id]); // if a string for the message id is missing

  cov_1o4vxlgso7.s[9]++;

  if (lstring === undefined) {
    cov_1o4vxlgso7.b[2][0]++;
    cov_1o4vxlgso7.s[10]++;
    return strings[lang]['StringMissing'];
  } else {
    cov_1o4vxlgso7.b[2][1]++;
  }

  cov_1o4vxlgso7.s[11]++;
  return lstring;
};

exports.localString = localString;